<div class="position-relative">
  <div *ngIf="loading"
    class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75 rounded-3"
    style="z-index: 2;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'loading' | translate }}</span>
    </div>
  </div>

  <div>{{ 'periods' | translate }}: {{ periods.length }} / {{ getMaxPeriods() }}</div>

  <ng-container *ngIf="periods.length > 0; else emptyState">
    <div class="d-flex flex-column gap-2">
      <div
        *ngFor="let period of periods"
        class="border rounded-3 p-3 d-flex align-items-center gap-3 bg-white w-100"
        [class.opacity-50]="!period.enabled">
        <div class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 lh-1 shadow-sm"
          [ngClass]="getPeriodBadgeClass(period.id)"
          style="width: 1.75rem; height: 1.75rem; font-size: 0.8rem;">
          <span class="fw-semibold">{{ period.id +1}}</span>
        </div>

        <div class="flex-grow-1 min-w-0">
          <div class="d-flex align-items-center gap-2 min-w-0">
            <span class="fw-semibold text-dark text-truncate">
              {{ period.name || (('holidayPeriod' | translate) + ' ' + period.id) }}
            </span>
          </div>
          <div class="text-muted small">
            {{ formatRange(period) }}
          </div>
        </div>

        <div class="d-flex align-items-center gap-2 flex-shrink-0">
          <label class="switch-sm mb-0">
            <input
              type="checkbox"
              [id]="'lumPeriodEnabled-' + period.id"
              [name]="'lumPeriodEnabled-' + period.id"
              [checked]="period.enabled"
              [attr.aria-label]="'lumPeriodActive' | translate"
              (change)="togglePeriodEnabled(period)">
            <span class="slider round"></span>
          </label>
          <button type="button" class="btn btn-sm btn-link p-0 text-primary fs-6"
            (click)="openPeriodModal(period)"
            [attr.aria-label]="'edit' | translate"
            [title]="'edit' | translate">
            <i class="fas fa-edit"></i>
          </button>
          <span class="text-danger fs-6" [title]="'delete' | translate" (click)="deletePeriod(period)" >
            <i class="fa-solid fa-trash"></i>
          </span>
        </div>
      </div>

      <button type="button"
        class="btn btn-outline-primary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
        style="border-style: dashed;"
        [disabled]="!canAddPeriod || loading"
        (click)="openPeriodModal()">
        <i class="fa-solid fa-plus"></i>
        <span>{{ 'addPeriod' | translate }}</span>
      </button>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <div
      class="border border-2 border-dashed rounded-3 bg-light bg-opacity-25 d-flex align-items-center justify-content-center py-5">
      <div class="text-center text-muted px-4">
        <i class="fas fa-calendar-week fa-2x mb-3 opacity-50"></i>
        <p class="mb-0 small fw-semibold">{{ 'periods' | translate }}</p>
        <p class="mb-0 small opacity-75">{{ 'noHolidayPeriodsActive' | translate }}</p>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <button type="button" class="btn btn-outline-primary"
        [disabled]="!canAddPeriod || loading"
        [attr.aria-label]="'addPeriod' | translate" [title]="'addPeriod' | translate"
        (click)="openPeriodModal()">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </ng-template>
</div>
